// extracted by mini-css-extract-plugin
export default {"label_container":"InfoLabel_label_container__8lehY","valueBlock":"InfoLabel_valueBlock__vy708","readMore":"InfoLabel_readMore__7ZODj"};